export interface SpinnerProps {
    /** Diameter px. Default 24. */
    size?: number;
    /** Accessible label. Default "Loading". */
    label?: string;
}

export function Spinner({ size = 24, label = "Loading" }: SpinnerProps) {
    return (
        <span role="status" aria-label={label} className="inline-flex items-center justify-center">
            <span
                aria-hidden="true"
                className="block animate-spin rounded-full border border-border border-t-cta motion-reduce:animate-none"
                style={{ height: size, width: size }}
            />
        </span>
    );
}
